module.exports = __webpack_public_path__ + "static/artillerist-b3f9b651b21b0d94d47e73689df723a6.png";